$(document).ready((function() {
//     $(".usf-zone").on("swipeleft swiperight", ".usf-zone", (function(e) {
//         alert(e.type)
//     })), 
      
      $("body").on("click", ".header", (function(e) {
        $(".box-a1").find(".level-box").stop().slideUp(), $(this).closest(".box-a1").find(".level-box").stop().slideToggle(), $(this).toggleClass("header-active")
    })), 
        
//         $(document).mouseup((function(e) {
//         0 === $(e.target).closest(".usf-preview").length && $(".usf-remove").trigger("click")
//     })),
        
//         $(document).mouseup((function(e) {
//         0 === $(e.target).closest(".usf-facets-wrapper").length && $(".usf-close").trigger("click")
//     })),
        
        $("body").on("click", ".eye-icon-hover", (function() {
        $(this).parents("form").next().trigger("click")
    })), $(window).scroll((function() {
        var e = $(window).scrollTop();
        $(window).width() <= 768 && e >= 1 && $(".breaducrumb-wrapper").addClass("sticky-breadcrumb")
    })), $("body").on("click", ".stamped-badge-caption", (function() {
        $("html, body").animate({
            scrollTop: $("#stamped-carousel-scroll-wrapper").offset().top - 120
        }, 2e3)
    })), $("figure.single-img:gt(9)").hide();
    var e = Math.floor(7 * Math.random() + 1);
    $("figure.single-img:eq(" + e + ")").show(), $(".accordion_tab").click((function() {
        if ($(".accordion_tab").removeClass("show"), $(this).next(".accordion_content").is(":visible")) {
            var e = $(this);
            $(this).next(".accordion_content").slideUp((function() {}))
        } else $(".accordion").find(".accordion_content:visible").slideUp(), $(this).addClass("show"), $(this).next(".accordion_content").slideDown()
    }))
}));//# sourceMappingURL=/s/files/1/0515/3472/5313/t/59/assets/custom.js.map?v=1634756290
$(document).ready(function(){
  $('ul.shopify-tabs > li').click(function(){
    var tab_id = $(this).attr('data-tab');

    $(this).parent().find('li').removeClass('current');
    $('.shopify-tab-content').removeClass('current');

    $(this).addClass('current');
    $("#"+tab_id).addClass('current');
  })
  $('body').on('change', '.custom_size__wrpr.is_main .choose_size',function(){
    var size_val = $(this).val();
    $('.size_value').html(size_val);
    $('.remove_on_change').remove();
    if(size_val == 'IDK - Send me a Sizing Kit'){
      $('.custom_size__wrpr.is_main').after(`<div class="idk_text remove_on_change">Your free size-from-home kit will arrive within 2-3 days of your purchase. We'll begin making your Emblem as soon as you've texted us your ring size. <a style="color:#4d4d4d;" href="/pages/ring-sizing" target="_blank">Learn More ❐</a></div>`);
    }
    if(size_val == 'Not Listed Here'){
      $('.custom_size__wrpr.is_main').after(`<div class="custom_size__wrpr what_size  remove_on_change"><div class="custom_label"><label><span class="custom_title">What is your size?:</span></label></div><input type="text" name="properties[What is your size?]" maxlength="5" required="required"><div class="normal_text">Not a problem. Because all of our rings are made to order, we can make whatever size you need.</div></div>`);
    }
  });
  $('.vid-ply').on('click',function(){

    if($(this).attr('data-click') == 1) {
      $(this).attr('data-click', 0)
      $(".video-wrap").addClass('pause')
      $(".video-wrap").removeClass('play')
      $('#myvideo')[0].pause();
    } else {
      $(this).attr('data-click', 1)
      $(".video-wrap").addClass('play')
      $(".video-wrap").removeClass('pause')
      $('#myvideo')[0].play();
    }

  });
});
$(window).on('load',function(){
  $('.variant-selection').addClass('active');
});